import React from "react";
import Index from "../components/PayPal";

export default function PayPal() {
  return (
    <div>
      <Index />
    </div>
  );
}
